// Generated by BUCKLESCRIPT VERSION 4.0.18, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Fetch = require("bs-fetch/lib/js/src/Fetch.js");
var ReactDom = require("react-dom");

var DOM = /* module */[];

function fetch$1(url, reduce) {
  fetch(url, Fetch.RequestInit[/* make */0](undefined, {
                  "X-Requested-With": "XMLHttpRequest"
                }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(/* () */0)).then((function (prim) {
            return prim.json();
          })).then((function (value) {
          Curry._1(reduce, value);
          return Promise.resolve(value);
        }));
  return /* () */0;
}

var Fetch$1 = /* module */[/* fetch */fetch$1];

function mapToElement(mapFn, list_) {
  return $$Array.of_list(List.mapi(mapFn, list_));
}

var List$1 = /* module */[/* mapToElement */mapToElement];

function renderToElementByQuery(element, query) {
  document.querySelectorAll(query).forEach((function (e) {
          ReactDom.render(element, e);
          return /* () */0;
        }));
  return /* () */0;
}

var Render = /* module */[/* renderToElementByQuery */renderToElementByQuery];

function mark(str, sub) {
  if (sub === "") {
    return str;
  } else {
    var re = new RegExp("(" + (String(sub) + ")"), "gi");
    return str.replace(re, "<mark>$1</mark>");
  }
}

var $$String$1 = /* module */[/* mark */mark];

exports.DOM = DOM;
exports.Fetch = Fetch$1;
exports.List = List$1;
exports.Render = Render;
exports.$$String = $$String$1;
/* react-dom Not a pure module */
